module.exports = __webpack_public_path__ + "static/media/ly.2178201b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ly.svg
// module id = 918
// module chunks = 0